import { v4 } from "uuid";
import { applyGuestIdentity, userStore } from "@/redux/user";
import { GuestIdentity } from "@/util/guestIdentity";
import { wsConnectionStore } from "@/redux/wsConnection";
import { emit } from "./wsOutRoutes";
import { gamePlayStore } from "@/redux/gamePlay";

let pending: { requestId: string; identity: GuestIdentity; resolve: (error: string | null) => void; timer: ReturnType<typeof setTimeout> } | null = null;

export function guestNameResponse(data: any) {
  if (!pending || pending.requestId !== data.requestId) return;
  clearTimeout(pending.timer);
  const error = data.error || (data.username !== `G*${pending.identity.name}` ? "unavailable" : null);
  if (!error) applyGuestIdentity(pending.identity);
  pending.resolve(error);
  pending = null;
}

export async function changeGuestName(identity: GuestIdentity): Promise<string | null> {
  if (!userStore.getState().isGuest) return "invalid";
  if (!gamePlayStore.getState().gameEnded) return "playing";
  if (pending) return "unavailable";
  if (!wsConnectionStore.getState().wsConnected) {
    if (userStore.getState().persistentGuest) {
      const { renamePersistentGuest } = await import("./guestSession");
      return renamePersistentGuest(identity);
    }
    // Reading pages do not connect to the live chess server.
    applyGuestIdentity(identity);
    return null;
  }
  return new Promise((resolve) => {
    const requestId = v4();
    const timer = setTimeout(() => {
      if (pending?.requestId === requestId) { pending = null; resolve("unavailable"); }
    }, 8000);
    pending = { requestId, identity, resolve, timer };
    emit("guestName", { requestId, name: identity.name, generated: identity.generated });
  });
}
